import { TBeamCartLocalStorage } from "../shared/cart-contents";
import { getCookieValue } from "./cookies";
import { createScopedLocalStorage } from "./local-storage";

/**
 * Retrieves the Beam cart ID from cookies
 * @param CART_COOKIE_NAME - The name of the cookie that stores the Beam cart ID
 * @returns The Beam cart ID if present in cookies or local storage, otherwise null
 */
export const getBeamCartId = (CART_COOKIE_NAME: string, config: { apiKey: string }): string | null => {
  const localStorage = createScopedLocalStorage(config);

  // The cart cache is used to detect changes after page refreshes / across tabs
  const cachedCart: TBeamCartLocalStorage | null = localStorage.getItemJson("cart");

  // Get the Beam cart cookie
  const beamCartId: string | null = cachedCart?.beamCartId ?? getCookieValue(CART_COOKIE_NAME) ?? null;
  return beamCartId;
};

/**
 * Retrieves the external cart ID
 * @param CART_COOKIE_NAME - The name of the cookie that stores the external cart ID
 * @returns The external cart ID if available or null if neither is available
 */
export const getExternalCartId = (CART_COOKIE_NAME: string, config: { apiKey: string }): string | null => {
  const localStorage = createScopedLocalStorage(config);

  // The cart cache is used to detect changes after page refreshes / across tabs
  const cachedCart: TBeamCartLocalStorage | null = localStorage.getItemJson("cart");

  // Get external cart cookie
  const externalCartId: string | null = cachedCart?.cartId ?? getCookieValue(CART_COOKIE_NAME) ?? null;
  return externalCartId;
};
